import React from 'react'
import Button from './Button'

const DefaultAlertLibrary = ({ isOpen, onClose, onApply }) => {
    if (!isOpen) return null

    const defaultAlerts = [
        {
            id: 'da1',
            title: 'Earnings Surprise Watch',
            description: 'Notify when a stock in watchlist beats earnings estimates by >10%',
            type: 'event',
            icon: '📈'
        },
        {
            id: 'da2',
            title: 'RSI Oversold Reversal',
            description: 'RSI < 30 and price crosses above 20-day MA',
            type: 'quantitative',
            icon: '📉'
        },
        {
            id: 'da3',
            title: 'Unusual Volume Spike',
            description: 'Volume > 300% of 10-day average volume',
            type: 'quantitative',
            icon: '📊'
        },
        {
            id: 'da4',
            title: 'Golden Cross',
            description: '50-day MA crosses above 200-day MA',
            type: 'quantitative',
            icon: '✝️'
        },
        {
            id: 'da5',
            title: 'CEO/Insider Buying',
            description: 'Significant insider buying detected',
            type: 'content',
            icon: '👔'
        },
        {
            id: 'da6',
            title: 'Major News Sentiment Shift',
            description: 'Sentiment score changes by >2 points in 24h',
            type: 'content',
            icon: '📰'
        }
    ]

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col">
                {/* Header */}
                <div className="border-b border-gray-200 p-6 flex items-center justify-between">
                    <div>
                        <h2 className="text-xl font-bold text-gray-900">Default Alert Library</h2>
                        <p className="text-sm text-gray-500">Choose from popular pre-configured alerts</p>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl">✕</button>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto grid grid-cols-1 md:grid-cols-2 gap-4">
                    {defaultAlerts.map(alert => (
                        <div key={alert.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm transition-all">
                            <div className="flex items-start justify-between mb-2">
                                <span className="text-3xl">{alert.icon}</span>
                                <span className="text-xs font-medium px-2 py-1 bg-gray-100 text-gray-600 rounded-full capitalize">
                                    {alert.type}
                                </span>
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-1">{alert.title}</h3>
                            <p className="text-sm text-gray-600 mb-4 h-10">{alert.description}</p>
                            <Button
                                onClick={() => {
                                    onApply(alert)
                                    onClose()
                                }}
                                className="w-full bg-white border border-blue-600 text-blue-600 hover:bg-blue-50 text-sm py-1"
                            >
                                Use Template
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default DefaultAlertLibrary
